module.exports = "https://www.ilove11.top/img/pay_cropay.459d1b6c.png";